import { deleteStoredValue, getStoredValue, hasStoredValue, storeValue } from "../localStorage";
export var KEY_FIELD = 'OnboardingIntakes';
export function deleteStoredIntakes() {
  deleteStoredValue(KEY_FIELD);
}
export function getStoredIntakes() {
  return getStoredValue(KEY_FIELD);
}
export function hasStoredIntakes() {
  return hasStoredValue(KEY_FIELD);
}
export function storeIntakesValue(valueMonth) {
  storeValue(valueMonth, KEY_FIELD);
}